import { AnswerObject, OpenEndedAnswerType } from '@sm/question-widgets/respondent-survey';
import React, { createContext, useContext, useState, useCallback } from 'react';
import { SurveyContext } from './SurveyContext';
import { SingleTextboxOpenEndedQuestionQm } from './surveyTypes';

type CurrentPageContextType = {
  questions?: SingleTextboxOpenEndedQuestionQm[];
  answers?: AnswerObject | {};
  updateAnswers(answer: OpenEndedAnswerType): void;
};

export const CurrentPageContext = createContext<CurrentPageContextType>({
  questions: undefined,
  answers: undefined,
  updateAnswers: answer => {},
});

type Props = {
  children: React.ReactNode;
};

export function CurrentPageProvider({ children }: Props): React.ReactElement {
  const { pageQuestions: initialPageQuestions } = useContext(SurveyContext);
  // Local storage -> overrides data from survey.
  // Local storage should be cleared when we hit the next page button.

  const [questions] = useState(initialPageQuestions);

  const initialAnswers = questions?.reduce(
    (acc, curr) => ({ ...acc, [curr.id]: { questionId: curr.id, value: '', touched: false, isDirty: false } }),
    {}
  );

  // Hydrate answers
  const [answers, setAnswers] = useState<AnswerObject | undefined>(initialAnswers);

  const updateAnswers = useCallback(
    answer => {
      setAnswers({
        ...answers,
        [answer.questionID]: answer,
      });
    },
    [answers]
  );

  return (
    <CurrentPageContext.Provider
      value={{
        questions,
        answers,
        updateAnswers,
      }}
    >
      <>{children}</>
    </CurrentPageContext.Provider>
  );
}

export default CurrentPageProvider;
